import React, { useState } from "react";
import axios from "axios";

import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { ROLE_BASED_API } from "../../api/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { FcGoogle } from "react-icons/fc";
// import { FaApple } from "react-icons/fa";

import "./SignIn.css";

import signinImg from "../../assets/loginpage-image.png";
import logo from "../../assets/Skilledition-logo.png";

const SignIn = () => {
  const [signin, setSignin] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignin((prev) => ({ ...prev, [name]: value }));
  };

  const togglePassword = () => setShowPassword((prev) => !prev);


  const handleSigninSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      email: signin.email,
      password: signin.password,
    };

    try {
      const response = await axios.post(
        ROLE_BASED_API.ROLE_BASED_SIGNIN,
        payload
      );

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        // Store only token and user_id
        localStorage.setItem("token", data.token);
        localStorage.setItem("user_id", data.user.user_id);
        localStorage.setItem("userRole", data.user.role);

        setTimeout(() => {
          // Navigate based on role or dashboard
          if (data.user.role === "tutor") {
            if (data.user.status?.toLowerCase() === "published") {
              navigate("/header/tutor/dashboard");
            } else {
              navigate("/tutor-onboarding");
            }
            navigate("/tutor-onboarding");
          } else {
            navigate("/student/overview");
          }
        }, 1500);
      } else {
        showErrorToast(data.message);
      }
    } catch (error) {
      console.error("Signin Error:", error);
      // Clear password field
      setSignin((prev) => ({ ...prev, password: "" }));

      if (error.response && error.response.data) {
        // Server responded with non-2xx status (like 409)
        showErrorToast(error.response.data.message);
      } else {
        showErrorToast("Network error! Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="student-signin-section">
      <Container className="student-signin-container">
        <Row className="student-signin-row">
          {/* Left Side - signin Form */}
          <Col xs={12} md={6} className="student-signin-left">
            <div className="student-signin-content">
              <div className="student-signin-logo mb-4">
                <img src={logo} alt="Skilledition Logo" />
              </div>
              <h5 className="student-signin-title">Start Your Learning Journey </h5>
              <p className="student-signin-subtitle mb-3">
                Sign in to continue learning and track your progress 
              </p>

              {/* Social Login Buttons */}
              {/* <div className="student-signin-social-buttons">
                <Button
                  type="button"
                  className="student-signin-social-btn google-btn"
                >
                  <FcGoogle className="student-signin-social-icon me-2" /> Login
                  with Google
                </Button>
                <Button
                  type="button"
                  className="student-signin-social-btn apple-btn"
                >
                  <FaApple className="student-signin-social-icon me-2" /> Login
                  with Apple
                </Button>
              </div> */}

              {/*Divider */}
              {/* <div className="student-signin-divider">
                <span className="student-signin-divider-span">or</span>
              </div> */}

              {/* Email/Password Form */}
              <Form
                className="student-signin-form"
                onSubmit={handleSigninSubmit}
              >
                <Form.Group
                  controlId="email"
                  className="student-signin-form-group"
                >
                  <Form.Label className="student-signin-label">
                    Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="student-signin-input"
                    value={signin.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group
                  controlId="password"
                  className="student-signin-form-group"
                >
                  <Form.Label className="student-signin-label">
                    Password
                  </Form.Label>

                  <div className="student-signin-password-input-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter your password"
                      className="student-signin-input"
                      value={signin.password}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="student-signin-password-toggle-icon"
                      onClick={togglePassword}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </Form.Group>

                <div className="student-signin-login-link mb-3">
                  <p className="mb-0">
                    Not registered yet?{" "}
                    <Link to="/get-start" className="student-signin-login-anchor">
                      Sign Up
                    </Link>
                  </p>
                  <p className="mb-0">
                    <Link
                      to="/forgot-password"
                      className="student-signin-login-anchorsss"
                    >
                      Forgot password?
                    </Link>
                  </p>
                </div>

                <Button
                  type="submit"
                  className="student-signin-btn mt-2"
                  disabled={loading}
                >
                  {loading ? "Signing in..." : "Sign In"}
                </Button>
              </Form>
            </div>
          </Col>

          {/* Right Side - Image Section */}
          <Col xs={12} md={6} className="student-signin-right d-none d-md-flex">
            <div className="student-signin-right-content">
              <h2 className="student-signin-right-title">
                The Smart Way to Learn Practical Skills
              </h2>

              <p className="student-signin-right-desc">
                Master in-demand skills through practical learning.
              </p>

              <img
                src={signinImg}
                alt="signin Visual"
                className="student-signin-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SignIn;
